/**
 * @flow
 * @relayHash 83566ef59fde613dbecf36d02e576c61
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type TrackType = "education_park" | "health_park" | "homemade" | "shops" | "%future added value";
export type ShopsTrackTabsQueryVariables = {|
  input?: ?TrackType
|};
export type ShopsTrackTabsQueryResponse = {|
  +track_departments: $ReadOnlyArray<?{|
    +id: string,
    +ref_id: string,
    +name: string,
    +logo: ?string,
    +pinned_vendors: ?$ReadOnlyArray<?{|
      +id: string,
      +logo_url: ?string,
      +ref_id: string,
      +name: ?string,
      +rating_count: ?number,
      +avg_rating: ?number,
      +follow: ?boolean,
      +followed: ?boolean,
      +track: ?string,
      +city: ?{|
        +name: ?string
      |},
      +country: ?{|
        +name: ?string
      |},
      +featured: ?boolean,
      +departments: ?$ReadOnlyArray<?{|
        +id: string,
        +name: string,
      |}>,
      +track_sub_departments: ?$ReadOnlyArray<?{|
        +id: string,
        +name: string,
        +track_department_id: string,
        +ref_id: string,
      |}>,
    |}>,
  |}>
|};
export type ShopsTrackTabsQuery = {|
  variables: ShopsTrackTabsQueryVariables,
  response: ShopsTrackTabsQueryResponse,
|};
*/


/*
query ShopsTrackTabsQuery(
  $input: TrackType
) {
  track_departments(type: $input) {
    id
    ref_id
    name
    logo
    pinned_vendors {
      id
      logo_url
      ref_id
      name
      rating_count
      avg_rating
      follow
      followed
      track
      city {
        name
        id
      }
      country {
        name
        id
      }
      featured
      departments {
        id
        name
      }
      track_sub_departments {
        id
        name
        track_department_id
        ref_id
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "TrackType",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "type",
    "variableName": "input",
    "type": "TrackType"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "ref_id",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "logo",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "followed",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "rating_count",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "avg_rating",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "follow",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "logo_url",
  "args": null,
  "storageKey": null
},
v11 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "track",
  "args": null,
  "storageKey": null
},
v12 = [
  v4
],
v13 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "featured",
  "args": null,
  "storageKey": null
},
v14 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "departments",
  "storageKey": null,
  "args": null,
  "concreteType": "TrackDepartment",
  "plural": true,
  "selections": [
    v2,
    v4
  ]
},
v15 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "track_sub_departments",
  "storageKey": null,
  "args": null,
  "concreteType": "TrackSubDepartment",
  "plural": true,
  "selections": [
    v2,
    v4,
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "track_department_id",
      "args": null,
      "storageKey": null
    },
    v3
  ]
},
v16 = [
  v4,
  v2
];
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "ShopsTrackTabsQuery",
  "id": null,
  "text": "query ShopsTrackTabsQuery(\n  $input: TrackType\n) {\n  track_departments(type: $input) {\n    id\n    ref_id\n    name\n    logo\n    pinned_vendors {\n      id\n      logo_url\n      ref_id\n      name\n      rating_count\n      avg_rating\n      follow\n      followed\n      track\n      city {\n        name\n        id\n      }\n      country {\n        name\n        id\n      }\n      featured\n      departments {\n        id\n        name\n      }\n      track_sub_departments {\n        id\n        name\n        track_department_id\n        ref_id\n      }\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "ShopsTrackTabsQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "track_departments",
        "storageKey": null,
        "args": v1,
        "concreteType": "TrackDepartment",
        "plural": true,
        "selections": [
          v2,
          v3,
          v4,
          v5,
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "pinned_vendors",
            "storageKey": null,
            "args": null,
            "concreteType": "Shop",
            "plural": true,
            "selections": [
              v6,
              v2,
              v3,
              v4,
              v7,
              v8,
              v9,
              v10,
              v11,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "city",
                "storageKey": null,
                "args": null,
                "concreteType": "State",
                "plural": false,
                "selections": v12
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "country",
                "storageKey": null,
                "args": null,
                "concreteType": "Country",
                "plural": false,
                "selections": v12
              },
              v13,
              v14,
              v15
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "ShopsTrackTabsQuery",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "track_departments",
        "storageKey": null,
        "args": v1,
        "concreteType": "TrackDepartment",
        "plural": true,
        "selections": [
          v2,
          v3,
          v4,
          v5,
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "pinned_vendors",
            "storageKey": null,
            "args": null,
            "concreteType": "Shop",
            "plural": true,
            "selections": [
              v6,
              v2,
              v3,
              v4,
              v7,
              v8,
              v9,
              v10,
              v11,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "city",
                "storageKey": null,
                "args": null,
                "concreteType": "State",
                "plural": false,
                "selections": v16
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "country",
                "storageKey": null,
                "args": null,
                "concreteType": "Country",
                "plural": false,
                "selections": v16
              },
              v13,
              v14,
              v15
            ]
          }
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '66f3c461253581686002663c604a7bec';
module.exports = node;
